// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const CheckIcon = /* @__PURE__ */ createIcon(
  'check',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M19.293 5.793a1 1 0 1 1 1.414 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 16.086z',
      },
    ],
  ]
);
